import { Download } from "@mui/icons-material";
import { IconButton, Modal, Tooltip } from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
// import { Data } from "react-csv/components/CommonPropTypes";
import DashConsumoContratual from "../../components/classes/DashConsumoContratual";
import DownloadCSVModal from "../../components/common/DownloadCSVModal/DownloadCSVModal";
import Utils from "../../helper/utils";

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function DashboardConsumoGrid(
  props: DashboardConsumoGridPropsTypes
) {
  const { t } = useTranslation();
  const [rows, setRows] = useState<Data>([]);
  const [openDownloadCSVModal, setOpenDownloadCSVModal] = useState<boolean>(false);
  const columns: GridColumns = createColumns();

  useEffect(() => {
    fillTable(props.dashConsumoContratualArr);
  }, [props.dashConsumoContratualArr]);

  function createColumns(): GridColumns {
    let cols: GridColumns = [
      {
        field: "id",
        headerName: t("common.id"),
        width: 80,
        align: "center",
        headerAlign: "center",
        renderHeader: (item) => {
          return <div>#</div>;
        },
      },
      {
        field: "numeroContratoPortal",
        headerName: t("pages.dashboardContractualComsumption.text.portalContractNumber"),
        type: "string",
        width: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "numeroContratoSap",
        headerName: t("pages.dashboardContractualComsumption.text.sapContractNumber"),
        type: "string",
        width: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "idSku",
        headerName: t("common.sku"),
        type: "string",
        width: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "skuNome",
        headerName: t("common.description"),
        type: "string",
        width: 320,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "quantidadeProduzida",
        headerName: t("common.producedQuantity"),
        type: "string",
        width: 240,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            <p>
              {item.value.toString()}
            </p>
          );
        },
      },
      {
        field: "quantidadeTotal",
        headerName: t("common.contractTotalQuantiy"),
        type: "string",
        width: 240,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            <p>
              {item.value.toString()}
            </p>
          );
        },
      },
      {
        field: "porcentagemProduzida",
        headerName: t("common.percentageProduced"),
        type: "date",
        width: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            <p>
              {item.value.toString()}%
            </p>
          );
        },
      },
      {
        field: "porcentagemTempoContrato",
        headerName: t("common.percentageOfContractTime"),
        type: "date",
        width: 240,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "dataInicio",
        headerName: t("common.initialDate"),
        type: "string",
        width: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return <p>{new Date(item.value).toLocaleDateString("pt-BR")}</p>;
        },
      },
      {
        field: "dataTermino",
        headerName: t("common.endDate"),
        type: "string",
        width: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return <p>{new Date(item.value).toLocaleDateString("pt-BR")}</p>;
        },
      },
      {
        field: "variacaoMinima",
        headerName: t("common.minimalVariation"),
        type: "string",
        width: 160,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "variacaoMaxima",
        headerName: t("common.maximumVariation"),
        type: "string",
        width: 160,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
    ];
    return cols;
  }

  function fillTable(dashConsumoContratualArr: DashConsumoContratual[]) {
    let gridData: Data = [];
    dashConsumoContratualArr.forEach(
      (item: DashConsumoContratual, index: number) => {
        let json = JSON.parse(DashConsumoContratual.toJson(item));
        json.id = index;
        json.dataInicio = item.dataInicio
        json.dataTermino = item.dataTermino
        gridData.push(json);
      }
    );
    setRows(gridData);
  }

  const handleClickOpenDownloadCSV = () => {
    setOpenDownloadCSVModal(true);
  };

  function handleCloseDownloadCSVModal() {
    setOpenDownloadCSVModal(false);
  }

  return (
    <div style={{ height: "60vh", width: "100%" }}>
      <div className="containerToolbar">
        <Tooltip title={t("pages.dashboardContractualComsumption.text.downloadCsv")}>
          <span>
            <IconButton onClick={handleClickOpenDownloadCSV}>
              <Download />
            </IconButton>
          </span>
        </Tooltip>
      </div>
      <DataGrid
        rows={rows}
        columns={columns}
        rowsPerPageOptions={[50, 100, 250, 500]}
      />
      <Modal
        open={openDownloadCSVModal}
        onClose={handleCloseDownloadCSVModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <DownloadCSVModal
          handleClose={handleCloseDownloadCSVModal}
          rows={rows}
          columns={columns}
          name={t("pages.dashboardContractualComsumption.pageTitle")}
        />
      </Modal>
    </div>
  );
}

interface DashboardConsumoGridPropsTypes {
  dashConsumoContratualArr: DashConsumoContratual[];
}
